const en = {

  common: {
    loading: 'Loading...',
    error: 'Something went wrong',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    copy: 'Copy',
    copied: 'Copied!',
    goHome: 'Go Home',
    back: 'Back',
    playAudyn: 'Play Audyn',
    reload: 'Reload',
    or: 'or',
    you: 'you',
    vs: 'VS',
    songs: 'Songs',
    tracks: 'tracks',
    score: 'Score',
    rank: 'Rank',
    correct: 'Correct',
    accuracy: 'Accuracy',
    today: 'today',
    daily: 'Daily',
    streak: 'Streak',
    profile: 'Profile',
    guest: 'Guest',
  },

  nav: {
    dailyChallenge: 'Daily Challenge',
    leaderboard: 'Leaderboard',
    profile: 'Profile',
    logIn: 'Log in',
  },

  home: {
    title: 'Guess the Song',
    subtitle: 'Paste a Spotify playlist. Hear a clip. Name the track.',
    playersToday: '{count} player{s} today',
    playlistInput: 'https://open.spotify.com/playlist/...',
    loadPlaylist: 'Load Playlist',
    tryDemo: 'Try a demo — Today\'s Top Hits',
    recentlyPlayed: 'Recently played',
    featuredPlaylists: 'Popular playlists',
    songs: 'Songs',
    difficulty: 'Difficulty',
    gameMode: 'Game Mode',
    guessMode: 'Guess Mode',
    clips: 'Clips',
    startGame: 'START GAME',
    challengeFriend: '⚔️ Challenge a Friend',
    changePlaylist: 'Change playlist',
    playableTracks: '{count} playable tracks',
    playableOfTotal: '{playable} of {total} tracks playable',
    allGuessable: 'All {total} are in the guess list',
    loadingPreviews: 'Loading previews…',
    waitingPreviews: 'Previews are loading… please wait',
    previewsTimeout: 'Timed out waiting for previews. Try again in a moment.',
    back: 'Back',
    backToPlaylist: 'Back to playlist selection',

    beatScore: '⚔️ Beat {username}\'s score of {score}!',

    announcement: {
      title: '🎉 Now supporting large playlists!',
      message: 'Playlists with 100+ songs are now supported. They may take a short while to load.',
    },

    easy: 'Easy',
    easyDesc: 'Longer clips, more time to think',
    normal: 'Normal',
    normalDesc: 'The classic experience',
    hard: 'Hard',
    hardDesc: 'Blink and you miss it',

    classic: 'Classic',
    classicDesc: 'Score by clip stage only. No time pressure.',
    tickingAway: 'Ticking Away',
    tickingAwayDesc: 'Score decays the longer you take. Every second counts.',

    songTitle: 'Song Title',
    songTitleDesc: 'Name the track',
    artist: 'Artist',
    artistDesc: 'Name the artist',
  },

game: {
    tapToBegin: 'TAP TO BEGIN',
    tapToUnlock: 'Tap anywhere to unlock audio',
    listening: 'LISTENING...',
    ready: 'READY',
    tapReplay: 'Tap to replay',
    loadingAudio: 'LOADING...',
    skipped: 'SKIPPED',
    audioError: 'AUDIO ERROR',
    typeGuess: 'Type your guess...',
    typeArtist: 'Type the artist name...',
    checking: 'Checking...',
    skip: 'Skip',
    timePressure: 'Time pressure',
    nextSong: 'NEXT SONG',
    seeResults: 'SEE RESULTS',
    betterLuck: 'Better luck next time',
    correctArtist: 'Correct artist!',
    theArtistWas: 'The artist was: {artist}',
    openInSpotify: 'Open in Spotify',
    base: 'base',
    timePenalty: 'time penalty',
    streakMultiplier: '× {mult} streak',
    waitingPreviews: 'Waiting for previews to load...',

    kbPlay: '[Space] Play',
    kbGuess: '[Enter] Guess',
    kbClear: '[Esc] Clear',
  },

  end: {
    newPersonalBest: '🏆 NEW PERSONAL BEST!',
    copyLink: 'Copy Link',
    copyShareText: 'Copy Share Text',
    challengeFriend: 'Challenge a Friend',
    copyManually: 'Copy manually:',
    playAgain: 'Play Again',
    newPlaylist: 'New Playlist',
    viewLeaderboard: 'View Leaderboard',
    createAccount: 'Create an account to save your scores and earn badges',
    signUp: 'Sign Up',
    outOf: 'out of {max}',
    missedTracks: 'Missed tracks',
    scoreCard: 'Score Card',

    shareText: 'I scored {score}/{max} on {playlist} 🎵 ({difficulty} • {tracks} songs) — can you beat me? {link}',
  },

  daily: {
    title: 'DAILY CHALLENGE',
    todaysChallenge: 'Today\'s Challenge',
    classicMode: '🎵 Classic Mode • No time pressure',
    playToday: 'Play Today\'s Challenge',
    alreadyPlayed: '✅ You\'ve already completed today\'s challenge',
    signInToSave: 'Sign in to save your daily challenge streak',
    firstDay: 'First day! Keep it up.',
    dayStreak: '{count}-day streak',
    couldNotLoad: 'Could not load daily challenge',
    needsCache: 'The daily playlist needs to be played once to populate the cache.',
    alreadyPlayedToast: 'You\'ve already played today\'s challenge!',
  },

  leaderboard: {
    title: 'LEADERBOARD',
    global: '🏆 Global',
    daily: '📅 Daily',
    allTime: 'All Time',
    month: 'Month',
    week: 'Week',
    noEntries: 'No entries yet',
    beFirst: 'Be the first to play and earn your spot!',
    yourRank: 'Your rank',
    rankedByTimePressure: 'Ranked by score under time pressure',
    classicMode: '🎵 Classic',
    tickingMode: '⏱️ Ticking Away',
    songMode: '🎵 Song Title',
    artistMode: '🎤 Artist',
  },

  login: {
    title: 'Log In',
    email: 'Email',
    emailPlaceholder: 'you@example.com',
    password: 'Password',
    passwordPlaceholder: '••••••••',
    logInBtn: 'Log In',
    signingIn: 'Signing in...',
    noAccount: 'Don\'t have an account?',
    signUpLink: 'Sign Up',
    welcomeBack: 'Welcome back!',
    fillFields: 'Please fill in all fields',
    loginFailed: 'Login failed',
  },

  register: {
    title: 'Sign Up',
    saveProgress: 'Save Your Progress',
    saveProgressDesc: 'Create an account to keep your scores on the leaderboard.',
    username: 'Username',
    usernamePlaceholder: 'your_username',
    email: 'Email',
    emailPlaceholder: 'you@example.com',
    password: 'Password',
    passwordPlaceholder: 'Min 8 characters',
    bio: 'Bio',
    bioPlaceholder: 'A little about you...',
    optional: 'optional',
    createAccount: 'Create Account',
    saveAccount: 'Save Account',
    creating: 'Creating...',
    haveAccount: 'Already have an account?',
    logInLink: 'Log In',
    welcomeToAudyn: 'Welcome to Audyn!',
    accountCreated: 'Account created! Your scores have been preserved.',
    fillRequired: 'Please fill in all required fields',
    passwordMin: 'Password must be at least 8 characters',
    registrationFailed: 'Registration failed',
  },

  profile: {
    title: 'PROFILE',
    editProfile: 'Edit Profile',
    displayName: 'Display Name',
    displayNamePlaceholder: 'Display name (optional)',
    displayNameHint: '{count}/50 — Leave blank to show your username',
    bioPlaceholder: 'Write a short bio...',
    spotify: 'Spotify',
    spotifyPlaceholder: 'https://open.spotify.com/user/your_id',
    spotifyError: 'Must start with https://open.spotify.com/user/',
    instagram: 'Instagram',
    instagramError: 'Letters, digits, underscores and periods only (1–30 chars)',
    pinterest: 'Pinterest',
    pinterestError: 'Letters, digits, underscores and periods only (3–30 chars)',
    achievements: 'Achievements',
    playToEarn: 'Play games to earn achievements!',
    recentScores: 'Recent Scores',
    profileUpdated: 'Profile updated',
    avatarUpdated: 'Avatar updated',
    profileLinkCopied: 'Profile link copied!',
    signInToView: 'Sign in to view your profile',
    onlyJpgPngWebp: 'Only JPEG, PNG, or WebP',
  },

  publicProfile: {
    userNotFound: 'User not found',
    userNotExist: 'This user does not exist.',
  },

  share: {
    shareNotFound: 'Share not found',
    shareExpired: 'This share link may have expired or does not exist.',
    playThisPlaylist: 'Play This Playlist',
    goToAudyn: 'Go to Audyn',
  },

  room: {
    roomCode: 'Room Code',
    waitingForOpponent: 'Waiting for opponent...',
    shareCodeHint: 'Share the code or link. Room expires in 30 minutes.',
    cancelRoom: 'Cancel',
    opponent: 'Opponent',
    playAgain: 'Play Again',
    wonBy: 'You won by {diff} points! 🏆',
    tie: 'It\'s a tie!',
    lostBy: 'You lost by {diff} points',
    h2hChallenge: 'H2H Challenge',
    roomLinkCopied: 'Room link copied!',
    challengeLinkCopied: 'Challenge link copied! Send it to a friend.',
    noPlaylist: 'No playlist selected — please load a playlist first.',
  },

  errorBoundary: {
    title: 'Something went wrong.',
    message: 'Reload the page to try again.',
    reload: 'Reload',
  },

  languages: {
    en: 'English',
    hi: 'हिन्दी',
    es: 'Español',
    ja: '日本語',
    ko: '한국어',
  },
};

export default en;
